<template>
  <div>
    <div class="project">
      <el-row>
        <el-col>
          <div class="project-1">
            <div class="project-1-input">
              <el-form>
                <el-form-item label="项目名称" label-width="120px">
                  <el-input clearable v-model="query.project_name" placeholder="请输入项目名称" size='labge'></el-input>
                </el-form-item>
              </el-form>
            </div>
            <el-button v-if="JudgeButton(role_permission,'category/projectQuery')" type="primary" icon="el-icon-search" @click="query.page = 1; loading = true;getList()">搜索
            </el-button>
            <el-button v-if="JudgeButton(role_permission,'category/projectIncrease')" type="success" icon="el-icon-circle-plus" @click="title='新增服务项目';handleEdit();">新增</el-button>
          </div>
          <div class="project-2">
            <el-table v-loading='loading' stripe border :data="list">
              <el-table-column align='center' prop="category_name" label="类目名称">
              </el-table-column>
              <el-table-column align='center' prop="project_name" label="服务项目">
              </el-table-column>

              <el-table-column align='center' prop="add_time" label="创建日期">
              </el-table-column>
              <el-table-column align='center' prop="project_duration" label="最低服务时长(分)">
              </el-table-column>
              <el-table-column align='center' prop="project_status" label="状态">
                <template slot-scope="scope">
                  <el-switch :disabled="!JudgeButton(role_permission,'category/projectEdit')" @change="change($event, scope.row)" v-model="scope.row.project_status" :active-value="1" :inactive-value="0" 
                    active-color="#13ce66" inactive-color="#cccccc">
                  </el-switch>
                </template>
              </el-table-column>
              <el-table-column label="操作" align='center'>
                <template slot-scope="scope">
                  <el-button v-if="JudgeButton(role_permission,'category/projectEdit')" size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
                  <el-button v-if="JudgeButton(role_permission,'category/projectDelete')" size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination style="margin: 30px auto;text-align: center;" v-if="query.total > 0"
              @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.page"
              :page-sizes="[10, 20, 50, 100]" :page-size="query.page_limit"
              layout="total, sizes, prev, pager, next, jumper" :total="query.total">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 类目 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="30%" @close='close'>
      <el-form :model="form" :rules="rules" ref="form" label-width='150px'>
        <el-form-item label="服务类目: ">
          <el-input v-model="form.category_name" disabled placeholder="类目" autocomplete="off" :maxlength='15'>
          </el-input>
        </el-form-item>
        <el-form-item label="项目名称: " prop='project_name'>
          <el-input v-model="form.project_name" placeholder="项目名称" autocomplete="off" :maxlength='15'></el-input>
        </el-form-item>
        <el-form-item label="最低服务时长(分): " prop='project_duration'>
          <el-input type="number"
            @input="form.project_duration=form.project_duration.length > 4?form.project_duration.slice(0, 4):form.project_duration"
            v-model="form.project_duration" placeholder="请输入最低服务时长"></el-input>
        </el-form-item>
        <!-- <el-form-item label="状态: ">
			  <el-switch
			    v-model="form.project_status"
			    active-color="#13ce66"
			    inactive-color="#cccccc">
			  </el-switch>
			</el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import userInfoAPI from '@/api/api';
  export default {
    name: 'project',
    components: {
    },
    props: {},
    data() {
      return {
        loading: true,
        list: [],
        query: {
          category_id: '',
          project_name: '',
          page_limit: 10,
          page: 1,
          total: 0,
          project_status: ''
        },
        title: '',
        dialogFormVisible: false,
        form: {
          category_id: '',
          project_name: '',
          project_duration: '',
          project_id: ''
        },
        rules: {
          project_name: [{
            required: true,
            message: '请输入项目名称',
            trigger: 'blur'
          }],
          project_duration: [{
            required: true,
            message: '请输入最低服务时长',
            trigger: 'blur'
          }],
        }
      }
    },
    watch: {},
    computed: {
      role_permission() {
        return this.$store.getters.role_permission
      }
    },
  methods: {
      JudgeButton(list, rot) {
        let fal = false;
        list.forEach((i, l) => {
          if (i.path == rot) {
            return fal = true;
          }
        })
        return fal
      },
      close() { //弹窗关闭
        this.$refs['form'].resetFields(); //强制清理表格内容 
        this.dialogFormVisible = false;
      },
      change(e, row) {
        userInfoAPI.serviceProjectUpdate({
          project_id: row.project_id,
          status: row.project_status, // 1=启用 0=禁用
        }).then((res) => {
          if (res.data.code == 0) {
            this.$message({
              type: 'success',
              message: '更新成功'
            });
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        })
      },
      handleEdit(row) {
        if (row) {
          this.title = '编辑服务项目'
          this.form = JSON.parse(JSON.stringify(row))
        } else {
          this.title = '新增服务项目'
          this.form = {
            category_id: this.$route.query.category_id,
            category_name: this.$route.query.category_name,
            project_name: '',
            project_duration: '',
            project_id: ''
          }
        }
        this.dialogFormVisible = true
      },
      handleDelete(index, row) { //删除
        this.$confirm('是否确定要删除该服务项目？', '删除提醒', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          userInfoAPI.serviceProjectDel({
            project_id: row.project_id
          }).then((res) => {
            if (res.data.code == 0) {
              this.getList()
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }

          })
        })
      },
      submit() {
        if (this.form.project_id) {
          this.$refs['form'].validate((valid) => {
            if (valid) {
              userInfoAPI.serviceProjectEdit(this.form).then((res) => {
                if (res.data.code == 0) {
                  this.getList()
                  this.dialogFormVisible = false
                  this.$message({
                    type: 'success',
                    message: '编辑成功!'
                  });
                } else {
                  this.$message({
                    type: 'error',
                    message: res.data.msg
                  })
                }
              })
            }
          })
        } else {
          this.$refs['form'].validate((valid) => {
            if (valid) {
              userInfoAPI.serviceProjectAdd(this.form).then(() => {
                this.getList()
                this.dialogFormVisible = false
                this.$message({
                  type: 'success',
                  message: '新增成功!'
                });
              })
            }
          })
        }
      },
      getList() {
        userInfoAPI.serviceProjectList(this.query).then(res => {
          this.list = res.data.data.list || []
          this.query.total = res.data.data.page.count || 0
          this.loading = false
        })
      },
      handleSizeChange(val) {
        this.query.page_limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.query.page = val;
        this.getList();
      },
    },
    created() {
      console.log()
      if (this.$route.query.category_id) {
        this.form.category_id = this.$route.query.category_id
        this.query.category_id = this.$route.query.category_id

        this.getList();
      }
    },
    mounted() {
      this.getList();
    },
    beforeDestroy() {},
    destroyed() {}
  }
</script>
<style lang='scss' scoped>
  /deep/.el-dialog__title {
    color: #fff;
  }

  /deep/ .el-dialog__header {
    background-color: rgb(62, 62, 238);
  }

  /deep/ .el-dialog__headerbtn {
    i {
      color: #fff;
    }
  }

  .project {
    width: 100%;
    overflow: hidden;

    .project-2 {
      width: 100%;
      margin-left: 30px;
    }

    .project-1 {
      width: 100%;
      height: 30px;
      margin-top: 20px;
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      justify-content: left;

      .project-1-input {
        margin-top: 20px;
        width: 300px;
        margin-right: 20px;
      }
    }

    .project-4 {
      width: 100%;
    }

    .project-3 {
      width: 100%;
      height: 30px;
      margin-top: 20px;
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      justify-content: left;

      .project-1-input {
        margin-top: 20px;
        width: 300px;
        margin-right: 20px;
      }
    }
  }
</style>
